import { backendApi } from "@/services/api";
import type { Customer } from "./customer";

const customersApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    customersList: build.query<List, ListRequest>({
      query: (request) => ({
        url: `/customers`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
      providesTags: ["Customer"],
    }),
    getCustomer: build.query<Customer, GetRequest>({
      query: (request) => ({
        url: `/customers/${request.id}`,
        method: "GET",
      }),
      providesTags: ["Customer"],
    }),
    putCustomer: build.mutation<Customer, PutRequest>({
      query: (request) => ({
        url: `/customers`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: ["Customer"],
    }),
  }),
});

export const {
  useCustomersListQuery,
  useGetCustomerQuery,
  usePutCustomerMutation,
} = customersApi;

export interface PutRequest {
  id: string;
  name: string;
  street: string;
  houseNumber: string;
  city: string;
  zipCode: string;
}

export interface GetRequest {
  id: string;
}

export interface ListRequest {
  limit: number;
  offset: number;
}

export interface List {
  count: number;
  items: Customer[];
}
